import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import { useSelector } from "react-redux";
import {
  organizationNodesReady,
  pushNotificationNodes,
} from "../../redux/organization/selectors";
import { IAppState } from "../../redux/types";
import { RoleType } from "../../redux/users";
import { Dispatcher } from "../../service/RootDispather";

const DeviceInfoContext = createContext(undefined);

const GoToStatusContext = createContext(undefined);

const getGlobal = () => {
  try {
    if (typeof globalThis !== "undefined") return globalThis;
  } catch (e) {
    console.log("globalThis error");
  }
  try {
    // eslint-disable-next-line no-restricted-globals
    if (typeof self !== "undefined") return self;
  } catch (e) {
    console.log("self error");
  }
  try {
    if (typeof window !== "undefined") return window;
  } catch (e) {
    console.log("window error");
  }
  try {
    if (typeof global !== "undefined") return global;
  } catch (e) {
    console.log("global error");
  }
  console.log("unable to locate global object");
  return undefined;
};

const debugAndr = () => {
  const val = true;
  // eslint-disable-next-line no-new-func
  const andrCall = Function(`
            if (typeof Android !== 'undefined' && typeof Android.setDebug !== 'undefined') {
                Android.setDebug(${val});
            }`);
  andrCall();
};
const DeviceInfoProvider = ({ children }: { children: any }) => {
  const globalHere: any = getGlobal();
  const [app, setApp] = useState(globalHere?.deviceInfo);
  const checkGlobalData = useCallback(() => {
    if (globalHere?.deviceInfo) {
      setApp(globalHere?.deviceInfo);
    }
    if (globalHere?.deviceInfo)
      console.log(
        "deviceInfo" + globalHere?.deviceInfo + new Date().toTimeString()
      );
  }, [globalHere?.deviceInfo]);

  useEffect(() => {
    const timeot = setInterval(() => {
      checkGlobalData();
    }, 50);
    if (app !== undefined) clearInterval(timeot);
    return () => {
      clearInterval(timeot);
    };
  }, [app, checkGlobalData]);
  useEffect(() => {
    checkGlobalData();
  }, [globalHere?.deviceInfo, checkGlobalData]);
  return (
    <DeviceInfoContext.Provider value={app}>
      {children}
    </DeviceInfoContext.Provider>
  );
};
const GoToStatusProvider = ({ children }: { children: any }) => {
  const globalHere: any = getGlobal();
  const [app, setApp] = useState(globalHere?.goToStatus);
  const checkGoToStatus = useCallback(() => {
    if (globalHere?.goToStatus !== undefined) {
      setApp(globalHere?.goToStatus);
    }
  }, [globalHere?.goToStatus]);

  useEffect(() => {
    const timeot = setInterval(() => {
      checkGoToStatus();
    }, 700);

    return () => {
      clearInterval(timeot);
    };
  }, [app, checkGoToStatus]);
  return (
    <GoToStatusContext.Provider value={app}>
      {children}
    </GoToStatusContext.Provider>
  );
};

export const SubscribeDefault = {
  mobileId: "08fdee158800b901",
  serviceToken:
    "dXDxUcRqRoaYhuwj-KhOEM:APA91bEP3kl3O7fIR0DadM6u5xUCiRzNO1FvVGKAB0zlbJ8d1aLy01nJH-OEtxTHOCAKQHmIgSrkcJ-1FK5QpJJ2mHEicDT-gaeV_fBPFcRBE7fV19vt-Bu_JHuGG9s-dPK5sfiaEIK2",
  deviceType: "dont get ping but keep pinging",
  metadata:
    '/"board":"sdm660","bootloader":"unknown","brand":"Xiaomi","device":"nitrogen","display":"QKQ1.190910.002 test-keys","hardware":"qcom","manufacturer":"Xiaomi","model":"MI MAX 3","product":"nitrogen","id":"QKQ1.190910.002","type":"user","user":"builder","host":"c3-miui-ota-bd142.bj","radioVersion":"AT31c7-00087-0917_1716_23a2dce,AT31c7-00087-0917_1716_23a2dce","tags":"release-keys","versionRelease":"10","buildVersion":29,"incremental":"V12.0.1.0.QEDMIXM","codeName":"REL","base":1,"partition":"system","FingerprintedPartitions":"[android.os.Build$Partition@6eb5d568, android.os.Build$Partition@bbf26537, android.os.Build$Partition@2b6fc86e, android.os.Build$Partition@37b19947]","baseOs":"","previewSdk":0,"AndroidAppVersion":"2.6.1","AndoroidWebCleintVersion":"  1.1.83-22","SimOperatorByMnc":"25501:Vodafone UA"}',
  serviceTokenType: "firebase",
  debugMode: "true",
  nodeIds: [],
};

// const AccessTokenNativeInteractor = () => {
//     const tokenInfo = useContext(AccessTokenContext);
//     const rootDispatcher = Dispatcher();
//     //step 1
//     useEffect(() => {
//         if (tokenInfo) {
//             console.log('receive token' + new Date().toTimeString());
//             const tokenp = tokenInfo.slice(0, tokenInfo.indexOf('baseUrl'));
//             const urlp = tokenInfo.slice(tokenInfo.indexOf('baseUrl') + 7).replace(new RegExp('_', 'g'), '/');
//             console.log('if is Auth ', tokenInfo);
//             StorageHelper.instance.SaveAccessToken(tokenp);
//             StorageHelper.instance.SaveLoggedOut(false);
//             setBaseUrl(urlp);
//             rootDispatcher.setIsAuthenticated(true);
//         }
//         // return () => {
//         // };
//     }, [tokenInfo, rootDispatcher]);
//     return null;
// };
const DeviceNativeInteractor = () => {
  const deviceInfo = useContext(DeviceInfoContext);
  const rootDispatcher = Dispatcher();
  //step 1
  useEffect(() => {
    ping();
    console.log("first ping" + new Date().toTimeString());
  }, []);

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (deviceInfo === undefined) {
        console.log(
          "after 2 second we dont get device info, pns gate stop" +
            new Date().toTimeString()
        );

        rootDispatcher.subscribePostponed(SubscribeDefault);
      }
    }, 2000);

    return () => {
      clearInterval(timeout);
    };
  }, [deviceInfo, rootDispatcher]);

  // step 2

  const ping = () => {
    const pingAndr =
      // eslint-disable-next-line no-new-func
      Function(` if (typeof Android !== 'undefined' && typeof Android.Ping !== 'undefined') {
                        Android.Ping();
                } else
                    return false;
        `);
    console.log("before first ping");

    console.log("going to ping android");
    pingAndr();
    console.log("android was pinged");
  };
  const monitorNodes = useSelector(pushNotificationNodes);
  const ready = useSelector(organizationNodesReady);
  const [checkedOnEmpty, setcheckedOnEmpty] = useState(false);
  const { email, roleNameList } = useSelector(
    (state: IAppState) => state.userProfile
  );
  const { subscribeData } = useSelector(
    (state: IAppState) => state.healthCheck
  );

  useEffect(() => {
    if (ready && monitorNodes.length === 0 && !checkedOnEmpty) {
      //case of empty org
      console.log("case of empty org");
      rootDispatcher.subscribeForbidden("");
    } else if (ready && monitorNodes.length !== 0) {
      setcheckedOnEmpty(true);
    }
  }, [ready, monitorNodes, checkedOnEmpty, rootDispatcher]);

  // const deviceInfo = {
  //     mobileId: '08fdee158800b901',
  //     serviceToken:
  //         'dXDxUcRqRoaYhuwj-KhOEM:APA91bEP3kl3O7fIR0DadM6u5xUCiRzNO1FvVGKAB0zlbJ8d1aLy01nJH-OEtxTHOCAKQHmIgSrkcJ-1FK5QpJJ2mHEicDT-gaeV_fBPFcRBE7fV19vt-Bu_JHuGG9s-dPK5sfiaEIK2',
  //     deviceType: 'android',
  //     debugMode: 'true',
  //     serviceTokenType: 'firebase',
  //     metadata: '',
  // };

  useEffect(() => {
    if (
      deviceInfo?.mobileId &&
      deviceInfo?.mobileId !== "" &&
      (subscribeData === undefined ||
        JSON.stringify(subscribeData) === JSON.stringify(SubscribeDefault)) &&
      monitorNodes.length !== 0
    ) {
      console.log("try to check and subscribe");
      rootDispatcher.saveDevicePNInfo({
        ...deviceInfo,
        debugMode: "true",
        nodeIds: monitorNodes,
      });

      console.log("try to subscribe" + monitorNodes[0] + deviceInfo?.mobileId);
      rootDispatcher.subscribeNotification({
        ...deviceInfo,
        debugMode: "true",
        nodeIds: monitorNodes,
      });
    }
  }, [deviceInfo, monitorNodes, subscribeData, rootDispatcher]);
  useEffect(() => {
    if (subscribeData === undefined) return;
    if (subscribeData === null) return;
    if (monitorNodes.length !== 0) {
      const oldNodes =
        JSON.stringify(monitorNodes) !== JSON.stringify(subscribeData.nodeIds);
      if (oldNodes) {
        console.log(
          "try to resubscribe on node" +
            monitorNodes[0] +
            subscribeData?.mobileId
        );
        rootDispatcher.updatePushNotification({
          ...subscribeData,
          nodeIds: monitorNodes,
        });
      }
    }
  }, [monitorNodes, subscribeData, rootDispatcher]);

  useEffect(() => {
    if (email === undefined) return;

    if (
      email?.indexOf("vitconsole.loger") !== -1 ||
      email?.indexOf("newlinetechnologies") !== -1 ||
      email?.indexOf("tetelman") !== -1 ||
      email?.indexOf("+264") !== -1 ||
      roleNameList?.indexOf(RoleType.DEV) !== -1
    ) {
      debugAndr();
    }
  }, [email, roleNameList]);

  return null;
};

const setLoggedIn = (isLogged: boolean): void => {
  console.log("get into SET LOGGED IN " + isLogged);

  const loggedAndroid =
    // eslint-disable-next-line no-new-func
    Function(`if (typeof Android !== 'undefined' && typeof Android.setLoggedIn !== 'undefined')
        Android.setLoggedIn(${isLogged});`);

  console.log("send Android");
  loggedAndroid();
};

const redirectToBrowserLogin = (): void => {
  console.log("get into redirectToBrowserLogin ");

  const loggedAndroid =
    // eslint-disable-next-line no-new-func
    Function(`if (typeof Android !== 'undefined' && typeof Android.redirectToBrowserLogin !== 'undefined')
        Android.redirectToBrowserLogin();`);

  console.log("send tab Android");
  loggedAndroid();
};

export {
  debugAndr,
  DeviceInfoContext,
  DeviceInfoProvider,
  DeviceNativeInteractor,
  GoToStatusContext,
  GoToStatusProvider,
  redirectToBrowserLogin,
  setLoggedIn,
};
export default DeviceInfoContext;
